import styled from '@emotion/styled'
import { format } from 'date-fns'
import { observer } from 'mobx-react'

import commonRepo from '@/repository/common.repo'

import Tooltip from './Tooltip'

export const 추가요금기준툴팁 = observer(() => {
  return (
    <Tooltip
      Content={
        <>{commonRepo.isSchoolflat ? <추가요금기준툴팁_학교용 /> : <추가요금기준툴팁_학원용 />}</>
      }
      size={18}
    />
  )
})

const 추가요금기준툴팁_학교용 = () => {
  const { currentStudentContractPlan, nextStudentContractPlans } = commonRepo

  return (
    <>
      {(currentStudentContractPlan || nextStudentContractPlans?.length) && (
        <>
          {currentStudentContractPlan && (
            <>
              <S.Title>진행 중인 이용권 정보</S.Title>
              <p>
                이용권{' '}
                {currentStudentContractPlan.contractValue === null
                  ? '무제한'
                  : `${currentStudentContractPlan.contractValue}개`}
                ({format(currentStudentContractPlan.contractStartDate, 'yyyy.MM.dd')}
                {' ~ '}
                {currentStudentContractPlan.contractEndDate
                  ? format(currentStudentContractPlan.contractEndDate, 'yyyy.MM.dd')
                  : '해지 시까지'}
                )
              </p>
            </>
          )}
          {nextStudentContractPlans && nextStudentContractPlans.length > 0 && (
            <S.Title className="next">진행 예정 {nextStudentContractPlans.length}건</S.Title>
          )}
          {nextStudentContractPlans &&
            nextStudentContractPlans.length > 0 &&
            nextStudentContractPlans.map((plan, index) => {
              return (
                <p key={index}>
                  이용권 {plan.contractValue === null ? '무제한' : `${plan.contractValue}개`} (
                  {format(plan.contractStartDate, 'yyyy.MM.dd')} ~{' '}
                  {plan.contractEndDate
                    ? format(plan.contractEndDate, 'yyyy.MM.dd')
                    : '해지 시까지'}
                  )
                </p>
              )
            })}
        </>
      )}
    </>
  )
}

const 추가요금기준툴팁_학원용 = () => {
  return (
    <>
      <S.Title>추가 요금 기준</S.Title>
      {commonRepo.payment?.무제한_요금제_여부 ? (
        <p>무제한 요금제는 추가 과금이 발생하지 않습니다.</p>
      ) : commonRepo.payment?.선택월_사용일_과금기준_여부 ? (
        <p>
          사용기간 내 총 재원 일수가 {commonRepo.payment.과금_기준에_따른_조건}일 이상인
          <br />
          학생이 {commonRepo.payment.기본_요금_포함_학생수}명을 초과할 경우, 인당 추가금
          <br />
          (구간별 초과 금액)이 발생합니다.
        </p>
      ) : (
        <p>
          사용 기간 내 채점 문제 수가 {commonRepo.payment?.과금_기준에_따른_조건}문제 이상이
          <br />된 학생이 {commonRepo.payment?.기본_요금_포함_학생수}명을 초과할 경우
          <br />
          인당 추가금(구간별 초과 금액)이 발생하며
          <br />
          이는 기본 이용료와 함께 청구됩니다.
        </p>
      )}
    </>
  )
}

const S = {
  Title: styled.strong`
    display: block;
    font-weight: 700;
    margin-bottom: 3px;
    &.next {
      display: block;
      margin-top: 10px;
    }
  `,
}
